import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IDeviceRepository } from '../../repositories/interfaces/iDeviceRepository';
import ResponseError from '../../entities/errors/ResponseError';
import { APIPath } from '@intigral/constant';

export interface IDeleteDeviceUseCase {
    execute(username: string, apiKey: string, guid: string, token: string, identityToken: string): Promise<boolean>;
}

export class DeleteDeviceUseCase implements IDeleteDeviceUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get deleteDeviceRepository(): IDeviceRepository {
        return container.resolve<IDeviceRepository>(DI.REPOSITORIES.IDeviceRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        username: string,
        apiKey: string,
        guid: string,
        token: string,
        identityToken: string
    ): Promise<boolean | any> {
        const response = await this.deleteDeviceRepository.deleteDevice(username, apiKey, guid, token, identityToken);
        if (response.data?.status === 'SUCCESS') {
            return true;
        }
        if (response.error) {
            throw new ResponseError(
                { url: APIPath.DEVICE_DELETE },
                {
                    code: response.error.code || 0,
                    message: response.error.msg || 'Unknown error',
                }
            );
        }
        return false;
    }
}
